export default __webpack_public_path__ + "i18n/uk.c52f71b2c7e20eda9dd0cdea3261a6da.json";